import { importsLatestCountsSlice } from './counts';
import { importsLatestGetSlice } from './get';
import { importsLatestSalesforceSlice } from './salesforce';

export const {
	requestGetImportsLatestCounts,
	resetGetImportsLatestCounts
} = importsLatestCountsSlice.asyncActionCreators;

export const {
	requestGetImportsLatest,
	resetGetImportsLatest
} = importsLatestGetSlice.asyncActionCreators;

export const {
	requestGetImportsLatestSalesforce,
	resetGetImportsLatestSalesforce
} = importsLatestSalesforceSlice.asyncActionCreators;
